import { render, staticRenderFns } from "./delivery-express.vue?vue&type=template&id=0fd2bc0e&scoped=true"
import script from "./delivery-express.vue?vue&type=script&lang=js"
export * from "./delivery-express.vue?vue&type=script&lang=js"
import style0 from "./delivery-express.vue?vue&type=style&index=0&id=0fd2bc0e&prod&lang=scss&scoped=true"
import style1 from "./delivery-express.vue?vue&type=style&index=1&id=0fd2bc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2bc0e",
  null
  
)

export default component.exports